<template>
  <!-- 活动转盘活动-转盘活动配置 -->
  <div class="debris_formula_config-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="configVisible = true"
            >添加转盘配置</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="openDialog(1)"
            >添加转盘物品</el-button
          >
        </el-form-item>
        <el-form-item label="转盘类型">
          <el-select
            style="width: 140px"
            v-model="query.box_type"
            placeholder="转盘类型"
            @change="getData()"
          >
            <el-option :value="undefined">全部</el-option>
            <el-option label="热血盲盒转盘" :value="1"></el-option>
            <el-option label="普通盲盒转盘" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item> -->
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="box_type" label="转盘类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.box_type === 1">热血盲盒转盘</span>
            <span v-if="row.box_type === 2">普通开箱转盘</span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="物品" align="center">
          <!-- <template slot-scope="{ row }">
            <span>{{ row.name }}</span>
          </template> -->
        </el-table-column>
        <el-table-column label="物品图片" align="center">
          <template slot-scope="{ row }">
            <img style="width: 100px" :src="row.img" alt="" />
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="权重" align="center">
        </el-table-column>
        <el-table-column prop="name" label="概率" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.probability }}%</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button type="primary" size="small" @click="openDialog(2, row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="handleDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 添加转盘 -->
    <RotaryConfigDialog
      :visible="addVisible"
      @close="addVisible = false"
      @refresh="getData()"
    ></RotaryConfigDialog>
    <!-- 添加转盘的物品 -->
    <RotaryGoodsDialog
      v-model="dialogInfos"
      :visible="addGoodsVisible"
      :type="dialogType"
      @close="addGoodsVisible = false"
      @refresh="getData()"
    ></RotaryGoodsDialog>
    <!-- 转盘配置 -->
    <ConfigDialog
      v-model="dialogInfos"
      :visible="configVisible"
      :type="dialogType"
      @close="configVisible = false"
      @refresh="getData()"
    ></ConfigDialog>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import RotaryConfigDialog from '@/components/activities/rotary/RotaryConfigDialog.vue'
import RotaryGoodsDialog from '@/components/activities/rotary/RotaryGoodsDialog.vue'
import ConfigDialog from '@/components/activities/rotary/ConfigDialog.vue'

export default {
  components: {
    RotaryConfigDialog,
    RotaryGoodsDialog,
    ConfigDialog
  },
  data() {
    return {
      configVisible: false,//配置弹窗显示标志
      addVisible: false,//添加转盘弹窗显示标志
      addGoodsVisible: false,//添加物品弹窗显示标志
      loading: false,//加载动画
      switch_status: 0,//开关状态 0是关闭，1是打开
      query: {
        page: 1,
        box_type: undefined,
      },
      fromData: {
        start_time: '',
        end_time: '',
      },
      dataList: undefined,//数据列表
      list1: undefined,//列表一
      list2: undefined,//列表二
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//传给弹窗的数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  created() {
    this.getData()//获取数据列表
    // this.getSwitchStatus()//获取开关
  },
  methods: {
    getSwitchStatus() {
      //获取关闭/打开热血盲盒分级房间按钮状态
      getApiData('turntable_enable')
        .then(res => {
          if (res) {
            res.data ? this.switch_status = 1 : this.switch_status = 0
            this.fromData.start_time = res.start_time
            this.fromData.end_time = res.end_time
          }
        })
    },
    handleSwitch() {
      //关闭/打开热血盲盒分级房间面向所有用户还是部分用户
      let params = { "black": this.switch_status ? 1 : 0 }
      patchApiData('', params)
        .then(res => {
          this.$message.success('操作成功！')
          this.getSwitchStatus()//刷新
        }).catch(err => {
          //关闭/打开红包按钮失败，还原标志
          this.switch_status = this.switch_status ? 0 : 1
        })
    },
    handleSave() {
      //保存时间
      let params = this.fromData
      patchApiData(`11`, params).then(() => {
        this.$message.success('操作成功')
        this.getData()
      })
    },
    getData() {
      this.loading = true
      let params = this.query
      getApiData('turntable', params)
        .then(res => {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.addGoodsVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    handleDelete(row) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`turntable/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.getData()
        })
      })
    },
    handleExport() {
      this.buttonLoading = true

      http
        .get(
          api + 'user_debris_goods_export',
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '用户合成记录.xlsx'
          })
        }).finally(() => {
          this.buttonLoading = false
        })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData(1);
    },
  }
}
</script>
<style lang="less" scoped>
.formula-box {
  display: flex;
  // justify-content: center;
  align-items: center;
  font-size: 12px;
  .goods-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .debris-info-item {
    margin-right: 5px;
    .debris-info {
      .debris-img {
        border: 2px solid rgb(105, 202, 25);
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>